import omit from 'lodash/omit';
import omitBy from 'lodash/omitBy';

type IValue = string | string[] | number | number[] | null | undefined;

const isEmpty = (value: IValue): boolean => (
  value === null ||
  (value === 'null') ||
  value === undefined ||
  (value === 'undefined') ||
  (typeof value !== 'number' && value.length === 0)
);

export const cleanQueryParams = (query: {}): {} => omitBy(query, isEmpty);

export const getQueryString = (obj: {}): string => new URLSearchParams(cleanQueryParams(obj)).toString();

export const removeQueryParams = (query: {}, params: Array<string>): any => omit(query, params);

export const getCurrentPath = (path: string): string => path.split('?')[0].toString();

export const addQueryParams = (query: {}, params: {}): {} => ({ ...query, ...params });

export const parseQueryArrayParam = (queryParam: string): (string | number)[] => {
  if (!queryParam) return [];

  return decodeURIComponent(queryParam)
    .split(',')
    .map((item) => {
      const trimmed = item.trim();
      const num = Number(trimmed);
      return !Number.isNaN(num) ? num : trimmed;
    })
    .filter(Boolean);
};

export const removeQueryValue = (
  query: Record<string, any>,
  paramName: string,
  valueToRemove: string,
): Record<string, any> => {
  if (!query[paramName]) return query;

  const values = query[paramName].split(',').filter((value: string) => value !== valueToRemove);

  return values.length > 0
    ? { ...query, [paramName]: values.join(',') }
    : omit(query, [paramName]);
};
